/** Hardcoded sponsor brand shown in the shell nav. Becomes study-configurable
 *  once a participant-side brand source exists. */
export const SHELL_BRAND = {
  sponsorLine1: 'Unwind',
  sponsorLine2: 'Therapeutics',
} as const;
